import React from 'react';
import { useCart } from '../context/CartContext';

export const TIPO_DOCUMENTO_OPTS = [
  { value: 'remision', label: 'Cotización' },
  { value: 'iva', label: 'Factura' },
];

export const FORMA_PAGO_OPTS = [
  { value: 'contado', label: 'Contado' },
  { value: 'credito_15', label: 'Crédito 15 días' },
  { value: 'credito_20', label: 'Crédito 20 días' },
  { value: 'credito_30', label: 'Facturación a 30 días' },
];

export const TRANSPORTADORAS = [
  '',
  'Coordinadora',
  'Servientrega',
  'Interrapidísimo',
  'Envía',
  'TCC',
  'Deprisa',
  'Recoge en bodega',
  'Otra',
];

export function buildWebPedidoPayload(checkout, items) {
  let transportadora = checkout.transportadora?.trim() || null;
  if (transportadora === 'Otra') {
    transportadora = checkout.transportadora_otra?.trim() || null;
  }

  const extras = [];
  if (checkout.cliente_documento?.trim()) extras.push(`Doc: ${checkout.cliente_documento.trim()}`);
  if (checkout.cliente_ciudad?.trim()) extras.push(`Ciudad: ${checkout.cliente_ciudad.trim()}`);
  if (checkout.cliente_email?.trim()) extras.push(`Email: ${checkout.cliente_email.trim()}`);
  const notasParts = [checkout.notas?.trim(), extras.length ? extras.join(' · ') : null].filter(Boolean);

  const direccionParts = [
    checkout.cliente_direccion?.trim(),
    checkout.cliente_ciudad?.trim(),
  ].filter(Boolean);

  return {
    origen: 'web',
    cliente_nombre: checkout.cliente_nombre.trim(),
    cliente_telefono: checkout.cliente_telefono.trim(),
    sucursal_direccion: direccionParts.length ? direccionParts.join(', ') : null,
    notas: notasParts.length ? notasParts.join('\n') : null,
    transportadora,
    horario_recibo: checkout.horario_recibo?.trim() || null,
    tipo_documento: checkout.tipo_documento || null,
    forma_pago: checkout.forma_pago || null,
    items: items.map((i) => ({
      producto_id: i.producto_id || null,
      codigo: i.codigo,
      nombre: i.nombre,
      precio_unitario: i.precio,
      cantidad: i.cantidad,
      observaciones: i.observaciones?.trim() || null,
      opcion_id: i.opcion_id || null,
    })),
  };
}

export default function CheckoutForm() {
  const { state, dispatch } = useCart();
  const c = state.checkout;

  function set(field, value) {
    dispatch({ type: 'SET_CHECKOUT', data: { [field]: value } });
  }

  return (
    <div className="checkout-form">
      <h3>Datos de entrega</h3>

      <label className="field-label">
        Nombre / negocio <span className="req">*</span>
        <input
          type="text"
          autoComplete="organization"
          placeholder="Ej: Droguería Central"
          value={c.cliente_nombre}
          onChange={(e) => set('cliente_nombre', e.target.value)}
        />
      </label>

      <label className="field-label">
        Teléfono / WhatsApp <span className="req">*</span>
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          placeholder="Ej: 3001234567"
          value={c.cliente_telefono}
          onChange={(e) => set('cliente_telefono', e.target.value)}
        />
      </label>

      <label className="field-label">
        Documento / NIT <span className="optional">(opcional)</span>
        <input
          type="text"
          inputMode="numeric"
          placeholder="NIT o cédula"
          value={c.cliente_documento}
          onChange={(e) => set('cliente_documento', e.target.value)}
        />
      </label>

      <div className="checkout-row">
        <label className="field-label">
          Ciudad
          <input
            type="text"
            autoComplete="address-level2"
            placeholder="Ciudad"
            value={c.cliente_ciudad}
            onChange={(e) => set('cliente_ciudad', e.target.value)}
          />
        </label>
        <label className="field-label">
          Dirección
          <input
            type="text"
            autoComplete="street-address"
            placeholder="Calle, barrio..."
            value={c.cliente_direccion}
            onChange={(e) => set('cliente_direccion', e.target.value)}
          />
        </label>
      </div>

      <label className="field-label">
        Correo <span className="optional">(opcional)</span>
        <input
          type="email"
          autoComplete="email"
          placeholder="correo@ejemplo.com"
          value={c.cliente_email}
          onChange={(e) => set('cliente_email', e.target.value)}
        />
      </label>

      <h3 className="checkout-section">Entrega y facturación</h3>

      <label className="field-label">
        Transportadora <span className="optional">(opcional)</span>
        <select value={c.transportadora} onChange={(e) => set('transportadora', e.target.value)}>
          {TRANSPORTADORAS.map((t) => (
            <option key={t || 'none'} value={t}>
              {t || '— Sin transportadora —'}
            </option>
          ))}
        </select>
      </label>

      {c.transportadora === 'Otra' ? (
        <label className="field-label">
          Nombre transportadora
          <input
            type="text"
            placeholder="Escribir transportadora..."
            value={c.transportadora_otra}
            onChange={(e) => set('transportadora_otra', e.target.value)}
          />
        </label>
      ) : null}

      <label className="field-label">
        Horario para recibir <span className="optional">(opcional)</span>
        <input
          type="text"
          placeholder="Ej: Lun–Vie 8:00 am – 12:00 m"
          value={c.horario_recibo}
          onChange={(e) => set('horario_recibo', e.target.value)}
        />
      </label>

      <div className="checkout-row">
        <label className="field-label">
          Documento
          <select value={c.tipo_documento || 'remision'} onChange={(e) => set('tipo_documento', e.target.value)}>
            {TIPO_DOCUMENTO_OPTS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
        <label className="field-label">
          Forma de pago
          <select value={c.forma_pago || 'contado'} onChange={(e) => set('forma_pago', e.target.value)}>
            {FORMA_PAGO_OPTS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <label className="field-label">
        Notas del pedido
        <textarea
          rows={3}
          placeholder="Observaciones para oficina o bodega"
          value={c.notas}
          onChange={(e) => set('notas', e.target.value)}
        />
      </label>
    </div>
  );
}
